export default {
  setMeasurement(state, response) {
    state.measurement = response;
  }
};